// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import LanguageSelectorComponent from './languageSelector';
import { getActiveLanguage, switchActiveLanguage } from '../../store/activeLanguage';
import { getAvailableLanguages } from '../../store/wpSettings';
import type { ActiveLanguage } from '../../store/activeLanguage';
import type { Languages } from '../../types/settings';

type StateProps = {|
  activeLanguage: ActiveLanguage,
  languages: Languages,
|};

type DispatchProps = {|
  handleSelectLanguage: (language: string) => void,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

const LanguageSelector = ({
  activeLanguage,
  languages,
  handleSelectLanguage,
}: Props) => {
  if (languages.length === 0) {
    return null;
  }

  return (
    <LanguageSelectorComponent
      onSelectLanguage={language => handleSelectLanguage(language)}
      activeLanguage={activeLanguage}
      languages={languages}
    />
  );
};

const mapStateToProps = (state): StateProps => ({
  activeLanguage: getActiveLanguage(state),
  languages: getAvailableLanguages(state) || [],
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  handleSelectLanguage: language => {
    dispatch(switchActiveLanguage(language));
    window.location.href = `/${language}/`;
  },
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageSelector);
